import { COLORS } from '@btime/constants'
import React from 'react'

import { useShouldHideColors } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Text from '../../../../../components/pdf/Text'

const LabelValue = ({ label, value, children, plainValue, bold }) => {
  const hideColors = useShouldHideColors()

  const styles = {
    root: {
      paddingTop: 11,
      paddingBottom: 11,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: hideColors ? COLORS.black + '40' : COLORS.light3,
      width: '100%'
    },
    grid: {
      display: 'flex',
      flexDirection: 'row'
    },
    label: {
      paddingRight: 5,
      maxWidth: '85%'
    },
    value: {
      display: plainValue && 'flex',
      justifyContent: plainValue && 'flex-end'
    }
  }

  return (
    <div style={styles.root}>
      <div style={styles.grid}>
        <div style={styles.label}>
          <Text bold>{label}:</Text>
        </div>
        <div style={styles.value}>
          {plainValue ? (
            value
          ) : (
            <Text preLine bold={bold}>
              {value}
            </Text>
          )}
        </div>
      </div>
      {children}
    </div>
  )
}

export default LabelValue
